import { DateInputLocalized, ExportButtonDropdown, ExportType } from '@components'

import { Text } from '@billy/design-system'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useDownloadExportFile } from '@features/exports/hooks/useDownloadExportFile'

import { useSegment } from '../../../../hooks'
import { formatDate } from '../../../../utils'
import { ExportsCard } from '../ExportsCard'

const DEBTOR_LIST_EXPORT_URL = 'debtorList'

export const DebtorList = () => {
  const { t } = useTranslation()
  const { downloadExportFile } = useDownloadExportFile()
  const { track } = useSegment()

  const [debtorListData, setDebtorListData] = useState<Date | undefined | null>(new Date())

  const handleSelect = useCallback(
    (_: string, type: ExportType) => {
      downloadExportFile({
        exportUrl: DEBTOR_LIST_EXPORT_URL,
        type,
        queryParams: {
          date: formatDate(debtorListData),
        },
      })

      track('XXX - Mikkel - Exports', {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        export_type: 'Accounts receivable',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        file_format: type,
        period: formatDate(debtorListData),
      })
    },
    [debtorListData, downloadExportFile, track],
  )

  const handleChangeDebtorListData = useCallback(
    (date?: Date | null) => {
      setDebtorListData(date)
    },
    [setDebtorListData],
  )

  return (
    <ExportsCard
      description={t('exports.card.debtor_list.description')}
      title={t('exports.card.debtor_list.title')}
      actionButton={
        <ExportButtonDropdown
          exportTypesToSkip={[ExportType.RegnskabBasis, ExportType.Html]}
          onSelect={handleSelect}
          variant="outlined"
          fullWidth
        />
      }
    >
      <div>
        <Text colorVariant="label" weight="medium">
          {t('date')}
        </Text>
        <DateInputLocalized value={debtorListData} onChange={handleChangeDebtorListData} />
      </div>
    </ExportsCard>
  )
}
